import { toggleTrashed } from '../../services/topicService'
import { ContentType } from '@insided/shared/utils/contentType'
import { TOPIC } from '../../constants'

interface Props {
  topicId: number
  contentType: ContentType
  trashed: boolean
  onTrash: (trashed: boolean) => void
  onShowAlert: (type: 'success' | 'error', message?: string) => void
}

async function ToggleTrash ({ contentType, topicId, trashed, onTrash, onShowAlert }: Props) {
  try {
    await toggleTrashed(contentType, topicId, !trashed)
    onTrash(!trashed)
    onShowAlert?.('success', trashed ? TOPIC.RESTORED_SUCCESS_MESSAGE : TOPIC.TRASHED_SUCCESS_MESSAGE)
  } catch {
    onShowAlert('error')
  }
}

export default ToggleTrash
